export enum Environment {
    PRODUCTION = "PRODUCTION",
    SANDBOX = "SANDBOX",
    STAGING = "STAGING",
    PREPROD = "PREPROD",
}
